import { Outlet } from "react-router-dom";
import { Card } from "@mui/material";
import "./AppLayout.css"; // Custom CSS for Layout
import Header from "./Header";
export default function AppLayout() {
  return (
    <div className="main-content">
      <Header />

      <Card sx={{ padding: "1rem" }}>
        <Outlet />
      </Card>
    </div>
  );
}
